<template>
  <div class="misc-wrapper">
<!--    <b-link class="brand-logo">-->
<!--      <vuexy-logo />-->
<!--      <h2 class="brand-text text-primary ml-1">-->
<!--        ادمین زیره-->
<!--      </h2>-->
<!--    </b-link>-->

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mt-5">
          صفحه‌ای که دنبال آن بودید پیدا نشد!
        </h2>
<!--        <b-button-->
<!--          variant="primary"-->
<!--          class="mb-1 btn-sm-block"-->
<!--          :to="loginRoute()"-->
<!--        >برگشت</b-button>-->
      </div>
      <b-img
        fluid
        :src="imgUrl"
        alt="Not authorized page"
      />
    </div>
  </div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  name: 'NotAutorized',
  components: {
    VuexyLogo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      return getHomeRouteForLoggedInUser()
    },
  },
}
</script>
